var cssClassIdx = 0;
export function getClassId() {
    return cssClassIdx++;
}



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/svg/cssClassId.js
// module id = 576
// module chunks = 25